export class DashboardQuoteDetails {
  approvedDate: string
  buildTypeName: string
  cartridgeName: string
  customerName: string
  quoteId: number
  
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(json: any) {
    this.approvedDate = json.approvedDate
    this.buildTypeName = json.buildTypeName
    this.cartridgeName = json.cartridgeName
    this.customerName = json.customerName
    this.quoteId = json.quoteId
  }
}
  